import React, { useState } from 'react';
import './cssfiles/ProjectCards.css';

function ProjectCards() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const otherProjects = [
    {
      image: 'https://i.imgur.com/pq5IVNe_d.jpg?maxwidth=520&shape=thumb&fidelity=high',
      title: 'Curator-1',
      description: 'AI-powered backend platform that curates articles and news from RSS feeds worldwide. Built with Java, Spring Boot, PostgreSQL, and RESTful API architecture.',
    },
    {
      image: 'https://i.imgur.com/XjRmnjp_d.jpg?maxwidth=520&shape=thumb&fidelity=high',
      title: 'Escalayt',
      description: 'Internal ticketing platform for assigning and resolving support tickets within organizations. Built with Java, Spring Boot, Spring Security, and React frontend.',
    },
    {
      image: 'https://i.imgur.com/oIggXxO_d.jpg?maxwidth=520&shape=thumb&fidelity=high',
      title: 'Ivite',
      description: 'Cross-platform mobile app that curates photos from event attendees into a shared album. Built with React Native, REST API integration, and cloud storage.',
    },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div className='main-container'>

      {/* FEATURED PROJECT — StudyPaddy */}
      <div className="featured-project">
        <div className="featured-label">⭐ Featured Project</div>
        <div className="featured-card">
          <div className="featured-preview">
            <div className="browser-chrome">
              <div className="browser-dots">
                <span className="dot red"></span>
                <span className="dot yellow"></span>
                <span className="dot green"></span>
              </div>
              <div className="browser-url">studypaddy.com</div>
            </div>
            <iframe
              src="https://www.studypaddy.com"
              title="StudyPaddy Live Preview"
              className="featured-iframe"
              loading="lazy"
              sandbox="allow-scripts allow-same-origin"
            />
          </div>
          <div className="featured-info">
            <h3 className="featured-title">StudyPaddy</h3>
            <p className="featured-description">
              AI-powered learning platform featuring quiz generation from uploaded files or text,
              document summarization, and interactive file-based Q&A. Built end-to-end from backend to frontend.
            </p>
            <div className="featured-tech">
              <span className="tech-tag">Java</span>
              <span className="tech-tag">Spring Boot</span>
              <span className="tech-tag">React</span>
              <span className="tech-tag">AI Integration</span>
              <span className="tech-tag">PostgreSQL</span>
              <span className="tech-tag">REST APIs</span>
            </div>
            <a
              href="https://www.studypaddy.com"
              target="_blank"
              rel="noopener noreferrer"
              className="featured-cta"
            >
              Visit Live Site →
            </a>
          </div>
        </div>
      </div>

      {/* OTHER PROJECTS — stacked cards */}
      <div className="other-projects-label">Other Projects</div>
      <div className="projects-container">
        {otherProjects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => openModal(project.image)}
          >
            <img src={project.image} alt={project.title} className="project-image" />
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <span className="project-badge">📁 Source available on request</span>
            </div>
          </div>
        ))}
      </div>

      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content">
            <img src={selectedImage} alt="Full View" className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectCards;